import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { CreditCard, DollarSign } from 'lucide-react';
// Clock - commented out for Financial Reports feature (not yet implemented)
import { useDashboardAlerts } from '../../hooks/useDashboardAlerts';
import { AlertCard } from '../../components/dashboard/AlertCard';

export default function PaymentsPage() {
  const navigate = useNavigate();
  const { data: alerts = [] } = useDashboardAlerts();

  const paymentAlerts = alerts.filter(
    alert => alert.id === 'late-payments' || alert.id === 'pending-payments'
  );

  return (
    <div className="space-y-6">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-[#EBFFEE] mb-2">Payments</h1>
          <p className="text-white/80">Manage payments, view reports, and track billing</p>
        </div>

        {/* Payment Alerts */}
        {paymentAlerts.length > 0 && (
          <div className="mb-6">
            <AlertCard alerts={paymentAlerts} maxAlerts={5} />
          </div>
        )}

        {/* Quick Actions */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Card className="bg-[#221F1F] border-[#504A4A] hover:border-[#9B1421] transition-colors cursor-pointer" onClick={() => navigate('/billing/manual-payments')}>
            <CardHeader>
              <CardTitle className="text-[#EBFFEE] flex items-center gap-2">
                <DollarSign className="w-5 h-5 text-rollops-accent" />
                Manual Payments
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-[#A9A3A3] text-sm">
                Apply payments to subscriptions manually, bulk payments, and track amounts due
              </p>
            </CardContent>
          </Card>

          <Card className="bg-[#221F1F] border-[#504A4A] hover:border-[#9B1421] transition-colors cursor-pointer" onClick={() => navigate('/billing/reports')}>
            <CardHeader>
              <CardTitle className="text-[#EBFFEE] flex items-center gap-2">
                <CreditCard className="w-5 h-5 text-rollops-accent" />
                Billing Reports
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-[#A9A3A3] text-sm">
                View subscription reports, generate month-to-date and year-to-date reports
              </p>
            </CardContent>
          </Card>

          {/* TODO: Financial Reports - Feature not yet implemented
          Currently no financial data flows through the application
          Uncomment when feature is ready:
          <Card className="bg-[#221F1F] border-[#504A4A] hover:border-[#9B1421] transition-colors cursor-pointer" onClick={() => navigate('/financial-reports')}>
            <CardHeader>
              <CardTitle className="text-[#EBFFEE] flex items-center gap-2">
                <Clock className="w-5 h-5 text-rollops-accent" />
                Financial Reports
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-[#A9A3A3] text-sm">
                View sales totals, yearly reports, late payments, and payment blocks
              </p>
            </CardContent>
          </Card>
          */}
        </div>
      </div>
  );
}
